export const INITIAL_STATE = {
    profile: {},
    followUserIsLoading: false,
    followUserErrors: null,
    getProfileIsLoading: false,
    getProfileErrors: null,
    unfollowUserIsLoading: false,
    unfollowUserErrors: null,
}